import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
// Remplacer moment et dayjs par Luxon
//import { DateTime } from 'luxon'; // Utilisation de Luxon pour la gestion des dates

import { ToastrService } from 'ngx-toastr';
import { rapportsDir, dns } from 'src/app/global.config';
import {
  providers,
  reportOf,
} from 'src/app/client-management/import-export/report-item';
import {
  Group,
  ImportFileDto,
  RapportDto,
  VehiculesDto,
  PointInterest,
  PoiClient,
  ReportAuto,
} from '../../../../data-management/data-management.model';
import { DataManagementService } from '../../../../data-management/data-management.service';
import { rapportsItem } from '../../../../import-export/report-item';
import { NewImportExportRestService } from '../../../_service/new-import-export-rest.service';
import { NewImportExportHelperService } from '../../../_service/new-import-export-helper.service';
import { NewImportExportService } from '../../../_service/new-import-export.service';
import { User } from 'src/app/authentification/signin/credentials';
import { Router } from '@angular/router';
import { SigninService } from 'src/app/authentification/signin/signin.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AutoSendReportComponent } from '../../auto-send-report/auto-send-report.component';

@Component({
  selector: 'app-global-stop-report',
  templateUrl: './global-stop-report.component.html',
  styleUrls: ['./global-stop-report.component.scss'],
})
export class GlobalStopsReportComponent implements OnInit {
  file: Blob | null = null;
  vehicule$: Subscription;

  Selectedoption: string = 'ALL_VEHICULES';

  // Remplacer l'utilisation de moment() par Luxon
  // selected: { startDate: DateTime; endDate: DateTime } | null = {
  //   startDate: DateTime.local().startOf('day'),
  //   endDate: DateTime.local().endOf('day'),
  // };

  maxDate: Date = new Date();

  isDateOnly = false;
  // locale: LocaleConfig = {
  //   format: 'DD/MM/YYYY HH:mm',
  //   applyLabel: 'Appliquer',
  //   customRangeLabel: ' - ',
  //   daysOfWeek: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  //   monthNames: [
  //     'Janvier',
  //     'Février',
  //     'Mars',
  //     'Avril',
  //     'Mai',
  //     'Juin',
  //     'Juillet',
  //     'Août',
  //     'Septembre',
  //     'Octobre',
  //     'Novembre',
  //     'Décembre',
  //   ],
  //   firstDay: 1,
  // };

  //Selectedoption: string = 'ALL_VEHICULES';
  isShowingExcel: boolean = false;
  loading: boolean = true;

  groups: Group[] = [];
  vehicules: VehiculesDto[] = [];
  groupsItems: { id: number; text: string }[] = [];
  selectedGroupsItems: { id: number; text: string }[] = [];
  vehiculesItems: { id: number; text: string }[] = [];
  selectedVehicule: { id: number; text: string }[] = [];

  selectedGroupsHash: string = '';
  selectedVehiculesHash: string = '';

  selectReportOf = reportOf;

  isDownloading: boolean = false;
  repport: RapportDto = new RapportDto();
  templateDownloadLocation: string = rapportsDir;
  isSending:boolean=false;

  constructor(
    private importExportRestService: NewImportExportRestService,
    private importExportHelperService: NewImportExportHelperService,
    private importExportService: NewImportExportService,
    public dataManagementService: DataManagementService,
    private toastr: ToastrService,private dialog:MatDialog

  ) {}

  ngOnInit(): void {
    this.Selectedoption = 'ALL_VEHICULES';
    this.getGroups();
    this.getVehicules();
    this.selectReportOf = reportOf;

    this.importExportService.setPdfExistince(false);
    // this.showExcel();
    var toDay = new Date();
    this.repport.dateInterval.startDate = new Date(
      toDay.getFullYear(),
      toDay.getMonth(),
      toDay.getDate(),
      0,
      0,
      0,
      0
    );
    this.repport.dateInterval.endDate = new Date(
      toDay.getFullYear(),
      toDay.getMonth(),
      toDay.getDate(),
      23,
      59,
      59,
      59
    );
    this.repport.dateInterval.startDate.setTime(
      this.repport.dateInterval.startDate.getTime()
    );

    this.importExportService.isSending().subscribe((s)=>{
      this.isSending=s
    })
  }

  ngOnDestroy(): void {
    if (this.vehicule$) {
      this.vehicule$.unsubscribe();
    }
    this.importExportService.setShowPdf(false);
  }

  openAutoSend(){
    this.dialog.open(AutoSendReportComponent,{
      width:"600px",
            data:{repport:this.repport,urlToBack:"stops/globalStop?timezoneOffset="}
    })

  }


  onSelectingReportOf() {
    /**give ability to downoald */

    this.loading = true;
    switch (this.Selectedoption) {
      case 'ALL_VEHICULES':
        this.repport.rapportPayloadDto.allVehicules = true;
        this.repport.rapportPayloadDto.byGroups = false;
        this.repport.rapportPayloadDto.byVehicules = false;
        break;
      case 'BY_GROUPS':
        this.repport.rapportPayloadDto.allVehicules = false;
        this.repport.rapportPayloadDto.byGroups = true;
        this.repport.rapportPayloadDto.byVehicules = false;
        break;
      case 'BY_VEHICULE':
        this.repport.rapportPayloadDto.allVehicules = false;
        this.repport.rapportPayloadDto.byGroups = false;
        this.repport.rapportPayloadDto.byVehicules = true;
        break;
      default:
        this.repport.rapportPayloadDto.allVehicules = true;
    }
  }

  selectedGroups(groups: { id: number; text: string }[]): void {
    let prefix = '';
    this.selectedGroupsHash = '';
    groups.forEach((group) => {
      this.selectedGroupsHash += prefix + group.id;
      prefix = ',';
    });
    this.repport.rapportPayloadDto.idGroups = this.selectedGroupsHash
      .split(',')
      .map((x) => +x);
  }

  selectedVehicules(vehicules: { id: number; text: string }[]): void {
    let prefix = '';
    this.selectedVehiculesHash = '';
    vehicules.forEach((vehicule) => {
      this.selectedVehiculesHash += prefix + vehicule.id;
      prefix = ',';
    });
    this.repport.rapportPayloadDto.idVehicules = this.selectedVehiculesHash
      .split(',')
      .map((x) => +x);
  }

  getGroups(): void {
    this.importExportRestService.getAllGroups().subscribe((groups) => {
      this.groups = groups;
      this.groupsToItems(groups);
    });
  }

  getVehicules(): void {
    this.importExportRestService.getAllVehicules().subscribe((vehicules) => {
      this.vehicules = vehicules;
      this.vehiculesToItems(vehicules);
    });
  }

  groupsToItems(groups: Group[]): void {
    this.groupsItems = groups.map((group) => ({
      id: group.idGroupe,
      text: group.nom,
    }));
  }

  vehiculesToItems(vehicules: VehiculesDto[]): void {
    this.vehiculesItems = vehicules.map((vehicule) => ({
      id: vehicule.idVehicule,
      text: vehicule.matricule,
    }));
  }

  showExcel(): void {
    this.isShowingExcel = true;
    this.importExportRestService.getGlobalStopsRepport(this.repport).subscribe(
      (blob) => {
        this.importExportService.setExcelToBeProcessed(blob);
        this.importExportService.setShowPdf(true);
        this.file = blob;
        this.isShowingExcel = false;

        this.toastr.success('Fichier chargé avec succès.');
      },
      (error) => {
        this.isShowingExcel = false;
        this.toastr.warning('Aucune donnée correspondante.');
      }
    );
  }

  downloadExcel(): void {
    this.isDownloading = true;
    this.importExportRestService.getGlobalStopsRepport(this.repport).subscribe(
      (blob) => {
        this.importExportService.setExcelToBeProcessed(blob);
        this.importExportService.setShowPdf(false);
        this.file = blob;
        this.isDownloading = false;
        this.importExportHelperService.downloadEasyPDF(
          blob,
          `Rapport_global_des_arrets.xlsx`
        );

        this.toastr.success('Fichier chargé avec succès.');
      },
      (error) => {
        this.isDownloading = false;
        this.toastr.warning('Aucune donnée correspondante.');
      }
    );
  }

  setTimeTo2359() {
    // Check if endDate is set and not just an empty string
    if (this.repport.dateInterval.endDate) {
      // Set the time to 23:59
      this.repport.dateInterval.endDate.setHours(23);
      this.repport.dateInterval.endDate.setMinutes(59);
    }
  }

  private getSelectedIds(): number[] {
    if (this.Selectedoption === 'BY_GROUPS') {
      return this.repport.rapportPayloadDto.idGroups || [];
    } else if (this.Selectedoption === 'BY_VEHICULE') {
      return this.repport.rapportPayloadDto.idVehicules || [];
    }
    return this.vehicules.map((v) => v.idVehicule);
  }
}
